import { useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { UploadSimple, CircleNotch } from "@phosphor-icons/react";

const CHUNK = 4 * 1024 * 1024;

async function sendChunk(vid, i, blob) {
  const fd = new FormData();
  fd.append("file", blob);
  try {
    await api.post(`/watch/upload/${vid}/chunk/${i}`, fd);
  } catch {
    await api.post(`/watch/upload/${vid}/chunk/${i}`, fd);
  }
}

export default function UploadVideo({ onDone }) {
  const inputRef = useRef(null);
  const [progress, setProgress] = useState(null);

  const upload = async (file) => {
    if (!file) return;
    if (file.size > 2 * 1024 * 1024 * 1024) return toast.error("Файл больше 2 ГБ");
    setProgress(0);
    try {
      const { data: init } = await api.post("/watch/upload/init", {
        name: file.name, size: file.size, content_type: file.type || "video/mp4",
      });
      const n = init.num_chunks;
      let done = 0;
      const queue = Array.from({ length: n }, (_, i) => i);
      const worker = async () => {
        for (;;) {
          const i = queue.shift();
          if (i === undefined) return;
          await sendChunk(init.video_id, i, file.slice(i * CHUNK, Math.min((i + 1) * CHUNK, file.size)));
          done += 1;
          setProgress(Math.round((done / n) * 100));
        }
      };
      await Promise.all(Array.from({ length: Math.min(3, n) }, worker));
      const { data } = await api.post(`/watch/upload/${init.video_id}/complete`);
      toast.success(`«${file.name}» загружено и добавлено в плейлист`);
      onDone?.(data.room);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setProgress(null);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept="video/*" className="hidden" data-testid="watch-upload-input"
        onChange={(e) => upload(e.target.files?.[0])} />
      <Button variant="outline" disabled={progress !== null} onClick={() => inputRef.current?.click()}
        data-testid="watch-upload-btn">
        {progress !== null
          ? <><CircleNotch size={16} className="mr-1.5 animate-spin" /><span className="num">{progress}%</span></>
          : <><UploadSimple size={16} className="mr-1.5" />Файл</>}
      </Button>
    </>
  );
}
